export default __webpack_public_path__ + "static/media/notes.3e6eabfd.svg";